import React, { useEffect, useRef, useState } from 'react'
import { Button, Fab, IconButton, Link, Menu, MenuItem, Tooltip, withStyles } from '@material-ui/core'
import Header from './Header'
import CommonLoader from '../CommonLoader'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import { deviceType, isMobile, isTablet } from 'react-device-detect'
import ForumIcon from '@material-ui/icons/ForumOutlined'
import customStyle from '../WebScreen/programInfo/CSS/stylesheet_UHS'
import MobileFooter from '../MobileScreen/MobileFooter'
import CommonFooter from './CommonFooter'
import { encryptMemberId } from '../ApiCall'
import { Modal } from 'react-bootstrap'
import CloseIcon from '@material-ui/icons/Close'
import ChatIcon from './ChatBox/ChatIcon'
import MobCopyright from '../MobileScreen/MobCopyright'

const CrudButton = withStyles(customStyle.crudBtn)(Fab)

const NextButton = withStyles({
  root: {
    width: '120px',
    height: '40px',
    backgroundColor: '#4782c4',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#4782c4',
      boxShadow: '0 4px 8px 0 #eae8db, 0 2px 4px 0 #eae8db'
    },
    '&:disabled': {
      backgroundColor: '#e1e1e3',
      color: '#ffffff'
    },
    '&:focus': {
      outline: 'none'
    }
  }
})(Button)

const HipaaAuth = props => {
  const [loader, setLoader] = useState(false)
  const [profileAnchorEl, setProfileAnchorEl] = useState(null)
  const [profileMenuOpen, setProfileMenuOpen] = useState(false)
  const [hipaaIframe, setHipaaIframe] = useState('')
  const [iframeHeight, setIframeHeight] = useState('auto')
  const [message, setMessage] = React.useState('')
  const [revokeConfirm, setRevokeConfirm] = useState(null)
  const iframeRef = useRef(null)

  useEffect(() => {
    const handleMessage = event => {
      if (event.data?.type === 'IFRAME_HEIGHT') {
        setIframeHeight(event.data.height)
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  useEffect(() => {
    const handleMessage = event => {
      if (event.data.type === 'HIPAA_EVENT') {
        setMessage(event.data.message)
      }
      if (event.data.type === 'HIPAA_REVOKE_CONFIRM') {
        setRevokeConfirm({ title: event.data.title, message: event.data.message })
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])
  useEffect(() => {
    getIfream()
  }, [])
  const getIfream = async () => {
    let baseURL = process.env.REACT_APP_COMMON_MODULE_URL
    let memberIdSource = localStorage.getItem('sourceid')
    let request = `memberid=${memberIdSource}&portal=member`
    let query = await encryptMemberId(request)
    setHipaaIframe(`${baseURL}hipaa?query=${query}&token=${localStorage.getItem('bearerToken')}`)
  }
  const goBack = () => {
    props.history.push('/')
  }
  const handleProfileMenuClose = () => {
    setProfileMenuOpen(false)
  }
  const handleProfileSettings = () => {
    handleProfileMenuClose()

    const sourceid = localStorage.getItem('sourceid')
    const subscriberName = localStorage.getItem('fullname')
    const email = localStorage.getItem('userMail')
    const nameParts = subscriberName.trim().split(' ')
    const firstName = nameParts[0] || ''
    const lastName = nameParts.slice(1).join(' ') || ''

    const profileConfig = {
      type: 'profile_settings',
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: localStorage.getItem('phone') || ''
    }

    // Try to call the plugin function with retry logic
    const attemptProfileLoad = (retries = 0) => {
      // Check if function exists on window
      if (typeof window.loadCommonPluginScreen === 'function') {
        try {
          window.loadCommonPluginScreen(sourceid, profileConfig)
          console.log('Profile settings opened successfully')
        } catch (error) {
          console.error('Error calling loadCommonPluginScreen:', error)
          alert('An error occurred while opening profile settings.')
        }
      } else if (retries < 5) {
        setTimeout(() => attemptProfileLoad(retries + 1), 300)
      } else {
        console.error('Plugin function loadCommonPluginScreen not available after retries')
      }
    }

    attemptProfileLoad()
  }
  const handleProfileClick = event => {
    setProfileAnchorEl(event.currentTarget)
    setProfileMenuOpen(true)
  }

  const handleLogout = () => {
    localStorage.clear()
    sessionStorage.clear()
    window.location.href = '/login'
  }

  const statusUpdateAndCloseModal = () => {
    setMessage('')
    console.log(iframeRef.current)
    console.log(iframeRef.current?.contentWindow)
    iframeRef.current.contentWindow.postMessage(
      {
        type: 'HIPAA_POPUP_RESULT',
        completed: true,
        memberId: localStorage.getItem('sourceid')
      },
      '*'
    )
  }

  // Reply to the HIPAA iframe's revoke confirmation request
  const answerRevokeConfirm = confirmed => {
    setRevokeConfirm(null)
    iframeRef.current.contentWindow.postMessage({ type: 'HIPAA_REVOKE_CONFIRM_RESULT', confirmed }, '*')
  }

  return (
    <div className="progInfoMainWrapper">
      {loader ? <CommonLoader /> : null}

      <div className="mobileViewHeader">
        <div className="mobile_header">
          <Link to="/">
            <ArrowBackIcon onClick={() => window.history.back()} style={{ width: '24px', height: '24px', color: '#2e3192' }} />
          </Link>
          <div className="mobile_header_title">HIPAA Privacy Authorization</div>

          <div className="appsicon_cursor">
            <IconButton onClick={handleProfileClick}>
              <AccountCircleIcon style={{ color: '#8283be' }} />
            </IconButton>
            <Menu anchorEl={profileAnchorEl} open={profileMenuOpen} onClose={handleProfileMenuClose} style={{ zIndex: 1000000 }}>
              {localStorage.getItem('SOURCE') !== 'NEO' && <MenuItem onClick={handleProfileSettings}>Profile Settings</MenuItem>}
              <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
            </Menu>
          </div>
        </div>
      </div>

      <div className="webHeader">
        <Header name={'HIPAA Privacy Authorization'} />
      </div>

      <div className="container progInfoContainer">
        <span className="Back_page" onClick={goBack}>
          <ArrowBackIcon style={{ width: '24px', height: '24px', color: ' #2e3192', marginRight: '5px' }} onClick={goBack} />
          BACK
        </span>
        <div className="commonWrap" style={{ paddingTop: '40px' }}>
          <div className="myNotificationSection_mob">
            <h2 className="progInfoTitle">HIPAA Privacy Authorization</h2>
            <div
              style={{
                width: '100%',
                backgroundColor: '#ffffff', // Match the iframe background
                lineHeight: 0, // Eliminates inline descender spacing
                fontSize: 0, // Removes whitespace text nodes
                overflow: 'hidden'
              }}
              className="hipaaIframe"
            >
              <iframe
                ref={iframeRef}
                src={hipaaIframe}
                title="HIPAA Auth"
                scrolling="no"
                style={{
                  width: '100%',
                  height: iframeHeight === 'auto' ? 'auto' : `${iframeHeight}px`,
                  border: 'none',
                  outline: 'none',
                  display: 'block', // CRITICAL: Changes iframe from inline to block
                  margin: 0,
                  padding: 0,
                  backgroundColor: '#ffffff'
                }}
              />
            </div>
          </div>
          {deviceType == 'browser' && (isMobile == false || isMobile == 'false') && (isTablet == false || isTablet == 'false') && (
            <Tooltip placement="top" arrow title="Chat with a Universal Health Fellowship Representative">
              <CrudButton
                className={'purechat-button-expand'}
                color="primary"
                onClick={() => window.pureChat()}
                aria-label="add"
                style={{
                  width: '65px',
                  height: '65px',
                  backgroundColor: '#ed1c24',
                  color: '#ffffff',
                  borderRadius: '50%',
                  border: 'none',
                  position: 'fixed',
                  right: '40px',
                  bottom: '40px',
                  zIndex: 109
                }}
              >
                <ForumIcon />
              </CrudButton>
            </Tooltip>
          )}
        </div>
        <div className="mobileFooter">
          <div
            style={{
              bottom: '9vh',
              paddingBottom: '7vh'
            }}
          >
            <ChatIcon shiftup={false} changeProgram={false} showAIChatIcon={true} />
            <div>
              <ChatIcon setAI={() => this.setState({ isAI: true })} />
            </div>
            <div>
              <MobCopyright />
            </div>
          </div>
        </div>
        <div className="webFooter">
          <CommonFooter />
        </div>
        <div className="mobileFooter">
          <MobileFooter />
        </div>
      </div>
      <Modal size="small" show={message} onHide={() => statusUpdateAndCloseModal()} centered backdrop="static">
        <Modal.Header style={{ alignItems: 'center', padding: '0.5rem 1rem' }}>
          <Modal.Title className="modeltitlestyle">Message</Modal.Title>
          <IconButton aria-label="close" onClick={() => statusUpdateAndCloseModal()}>
            <CloseIcon />
          </IconButton>
        </Modal.Header>

        <Modal.Body>
          <b>
            <span style={{ fontSize: '16px', fontWeight: '500' }}>{message}</span>
          </b>
        </Modal.Body>

        <Modal.Footer style={{ justifyContent: 'center' }}>
          <Button variant="secondary" onClick={() => statusUpdateAndCloseModal()} class="ButtonBG">
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal size="small" show={!!revokeConfirm} onHide={() => answerRevokeConfirm(false)} centered backdrop="static">
        <Modal.Header style={{ alignItems: 'center', padding: '0.5rem 1rem' }}>
          <Modal.Title className="modeltitlestyle">{revokeConfirm?.title}</Modal.Title>
          <IconButton aria-label="close" onClick={() => answerRevokeConfirm(false)}>
            <CloseIcon />
          </IconButton>
        </Modal.Header>

        <Modal.Body>
          <span style={{ fontSize: '16px' }}>{revokeConfirm?.message}</span>
        </Modal.Body>

        <Modal.Footer>
          <Button  variant="contained" color="secondary" onClick={() => answerRevokeConfirm(false)} class="ButtonBG">
            CANCEL
          </Button>
          <Button variant="contained" color="primary" onClick={() => answerRevokeConfirm(true)} class="ButtonBG">
            REVOKE
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default HipaaAuth
